// @flow

import * as React from 'react';

import type { NavigationState } from '../../types';

const NavigationContext: React.Context<NavigationState> =
  React.createContext<NavigationState>({
    open: false,
    toggleOpen: () => {},
  });

export { NavigationContext };
export type { NavigationState };
